const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** True when value looks like a canonical UUID string. */
export function isUuid(value: string | null | undefined): boolean {
  return typeof value === 'string' && UUID_RE.test(value.trim());
}

/** Keep only canonical UUID strings (deduped, order preserved). */
export function filterValidUuids(ids: readonly (string | null | undefined)[]): string[] {
  const seen = new Set<string>();
  const valid: string[] = [];
  for (const raw of ids) {
    if (raw == null || !isUuid(raw)) continue;
    const id = raw.trim();
    if (seen.has(id)) continue;
    seen.add(id);
    valid.push(id);
  }
  return valid;
}

/** @deprecated use filterValidUuids — kept for delivery-specific call sites */
export function filterValidDeliveryIds(ids: readonly (string | null | undefined)[]): string[] {
  return filterValidUuids(ids);
}
